/* eslint-disable max-len */
/* eslint-disable no-console */
import isScreenMobileSize from '@gcc/pip-components/dist/utils/isMobile';
import { format } from 'date-fns';
import {
  setPageInfo,
  setAdditionalPageInfo,
  setAuthenticationStatus,
  setUserLocalization,
  setSiteInfo,
  setProfileInfo,
  setb2bProfile,
} from './digitalDataBuilder';

import {
  getAnalyticsAuthenticationStatus,
  isLoggedIn,
  getProfileId,
  getb2bProfile,
  isB2BUser,
  getSiteInfo,
} from './thdUserInfo';

import { sendAddToCartEvent } from '.';

const setTheHomeDepotCategoryObject = (
  omsId,
  productName,
  brand,
  logEventsToConsole,
  omnitureInfo,
  sendPaymentEstimatorImpressionToAnalytics,
  thdStoreInfo,
  etaInfo
) => {
  const categoryData = omnitureInfo;
  const storeInfo = thdStoreInfo;

  setAdditionalPageInfo('category', categoryData);

  const pageInfoData = {
    pageLoadEvent: 'product view',
    pageName: `productdetails>${omsId}`,
    pageType: 'pip',
  };

  setAdditionalPageInfo('pageInfo', pageInfoData);

  // const { startDate, endDate } = etaInfo;
  const itemData = {
    productInfo: {
      sku: `${omsId}`,
      name: productName,
      manufacturer: `${brand}`,
      productType: 'merchandise',
      department: '25',
      class: '5',
      subclass: '8',
      eta: {
        sthStartDate: etaInfo?.startDate ? format(etaInfo?.startDate, 'YYYY-MM-DD') : 'n/a',
        sthEndDate: etaInfo?.endDate ? format(etaInfo?.endDate, 'YYYY-MM-DD') : 'n/a',
      },
      availabilityStatus: {
        shipping: {
          sth: 'available',
          boss: 'available',
          skuStatus: 'active',
        },
        store: {
          skuStatus: 'n/a',
        },
        type: 'shared',
        backOrder: 'false',
      },
    },
  };

  setAdditionalPageInfo('item', itemData);

  if (sendPaymentEstimatorImpressionToAnalytics) {
    const paymentEstimatorImpressionData = {
      name: 'buy box',
      feature: 'plcc-est',
      type: 'cta',
    };
    setAdditionalPageInfo('content', paymentEstimatorImpressionData);
  }
  if (storeInfo) {
    setUserLocalization(storeInfo);
  }

  const siteInfo = {
    experienceType: isScreenMobileSize() ? 'mobile' : 'desktop',
    betaSite: getSiteInfo() === 'origin' ? 'prod': 'beta',
    businessType: isB2BUser() ? 'b2b' : 'b2c',
  };

  setSiteInfo(siteInfo);

  if (logEventsToConsole) {
    console.log('window.digitalData', JSON.stringify(window.digitalData));
  }
};

export const customProductPipLoaded = (
  omsId,
  productName,
  brand,
  logEventsToConsole,
  omnitureInfo,
  sendPaymentEstimatorImpressionToAnalytics,
  thdStoreInfo,
  etaInfo
) => {
  const pageName = `productdetails>${omsId}`;
  setPageInfo('product view', pageName, 'pip');
  setTheHomeDepotCategoryObject(
    omsId,
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    thdStoreInfo,
    etaInfo
  );
  setAuthenticationStatus(getAnalyticsAuthenticationStatus());
  if (isLoggedIn()) {
    setProfileInfo(getProfileId());
    setb2bProfile(getb2bProfile());
  }
};

export const addToCartAnalytics = (items, logEventsToConsole) => {
  if (logEventsToConsole) {
    console.log('addToCartAnalytics items', JSON.stringify(items));
  }
  sendAddToCartEvent(items);
};
